<div style="margin: 0 !important;" class="d-flex align-items-center justify-content-between" mat-dialog-title>
    <div class="d-flex flex-column align-items-start justify-content-end">
        <h3>{{data?.name ?? 'Image preview'}}</h3>
        <p>{{data.time ? data.time.toString().split('GMT')[0] : 'Unknown time'}}</p>
    </div>
    <div style="gap: 15px;" class="d-flex-align-items-center justify-content-center">
        <mat-icon (click)="this.rotateAngle = this.rotateAngle + 90">rotate_left</mat-icon>
        <mat-icon (click)="this.rotateAngle = this.rotateAngle - 90">rotate_right</mat-icon>
        <mat-icon (click)="onClose()" style="color: red;">close</mat-icon>
    </div>
</div>

<div style="width: 95vw; height: 70vh;" class="d-flex align-items-center justify-content-center" mat-dialog-content
    *ngIf="data.imageSource">
    <pinch-zoom [limitPan]="false" [autoHeight]="true" backgroundColor="transparent" style="height: 70vh;" overflow="visible">
        <img #galleryImage [ngStyle]="{'rotate': rotateAngle+'deg', 'scale': getImageScale()}"
            [src]="data.imageSource">
    </pinch-zoom>
</div>